import API, { defaultHeaders, IRI } from './index';

const fetchExam = courseId => {
  const headers = Object.assign({}, defaultHeaders);
  return fetch(`${API}${IRI.courseExam}${courseId}`, { headers });
};

const fetchExamResults = payload => {
  const headers = Object.assign({}, defaultHeaders);
  return fetch(`${API}${IRI.examAnswers}/`, {
    headers,
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

const fetchDownloadCertificate = payload => {
  const headers = Object.assign({}, defaultHeaders);
  const serialize = obj => {
    const str = [];
    for (const p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      }
    return str.join('&');
  }

  const a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);
  a.href = `${API}${IRI.downloadCertificate}?${serialize(payload)}`;
  a.setAttribute('download', 'certifikat.pdf');
  a.click();
  window.URL.revokeObjectURL(a.href);
  document.body.removeChild(a);
};

export {
  fetchExam,
  fetchExamResults,
  fetchDownloadCertificate,
};
